export const environment = {
  production: false,
  API_URL: 'https://jolly-hill-0b53e9403-dev.westeurope.2.azurestaticapps.net/api',
  APP_NAME: 'Gearbox Web APP Dev',
  WEB_SOCKET_URL: 'ws://localhost:5000/asd',
  POLLING_INTERVAL: 5000,
  AZURE_ENTRA_CLIENTID: 'd51a4a40-fa3f-4591-95fb-73724c918157',
  AZURE_ENTRA_AUTHORITY: 'https://login.microsoftonline.com/3ab4e0b8-fd49-4b7d-819b-b92b8e5fb6a1',
   AZURE_ENTRA_REDIRECT_URI: 'https://jolly-hill-0b53e9403-dev.westeurope.2.azurestaticapps.net/dashboard/dashboard',
  //  AZURE_ENTRA_REDIRECT_URI: 'http://localhost:4200/dashboard/dashboard',

};
